<template>
  <div class="main-content">
    <div class="main-wrap">
      <el-form ref="form" class="job-edit-form" :model="form" size="small" label-width="100px">
        <div class="step-info">
          <span class="step-num">1</span>
          职位基本信息
        </div>
        <el-form-item label="职位名称：">
          {{form.jobName}}
        </el-form-item>
        <el-form-item label="职位类别：">{{form.positionName}}
        </el-form-item>
        <el-form-item label="工作性质：">{{form.jobNature}}
        </el-form-item>
        <el-form-item label="工作城市：">{{form.city}}
        </el-form-item>
        <el-form-item label="工作地址：">{{form.workAddress}}
        </el-form-item>
        <el-form-item label="职位诱惑：">{{form.jobAdvantage}}
        </el-form-item>
        <div class="step-info" style="margin-top:34px">
          <span class="step-num">2</span>
          职位要求
        </div>
        <el-form-item label="工作经验：">{{form.workExp}}
        </el-form-item>
        <el-form-item label="学历要求：">{{form.degree}}
        </el-form-item>
        <el-form-item label="月薪范围：">{{form.salary}}
        </el-form-item>
        <el-form-item label="职位描述：">
          <p v-html="form.jobDescription"></p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    degreeList,
    jobNatureList,
    postExperienceList
  } from '~/static/basicData';
  import cityList from '~/static/citys';

  import {
    getPositionList
  } from '~/api/common';

  import {
    getJobInfo
  } from '~/api/job';

  export default {
    data() {
      return {
        jobId: this.$route.query.id,
        jobNatures: jobNatureList,
        positions: [],
        positionProps: {
          value: 'id',
          label: 'text',
          children: 'child'
        },
        minSalarys: [],
        maxSalarys: [],
        maxSalaryShow: false,
        citys: cityList.data,
        degrees: degreeList,
        postExperiences: postExperienceList,
        form: {
          jobName: '',
          position: '',
          jobNature: '',
          salary: '',
          city: '',
          workAddress: '',
          workExp: '',
          degree: '',
          jobAdvantage: '',
          jobDescription: ''
        },
      };
    },
    created() {
      this.getPositionList();
      this.initMinSalarys();
      if (this.jobId) {
        this.getJobInfo(this.jobId);
      }
    },
    methods: {
      getPositionList() {
        getPositionList().then(m => {
          if (m.errcode == 0) {
            this.positions = m.data;
          }
        });
      },
      onPositionChange(value) {
        if (Array.isArray(value) && value.length == 2) {
          this.form.positionId = value[1];
        }
      },
      onCityChange(value) {
        if (Array.isArray(value) && value.length == 3) {
          this.form.cityId = value[2];
        }
      },
      initMinSalarys() {
        this.minSalarys = [];
        for (var i = 1; i <= 45; i++) {
          this.minSalarys.push({
            label: i + 'K',
            value: i
          });
        }
      },
      buildMaxSalarys(val) {
        this.maxSalarys = [];
        for (var i = 1; i < 6; i++) {
          var n = val + i;
          this.maxSalarys.push({
            label: n + 'K',
            value: n
          });
        }
      },
      onMinSalaryChange(val) {
        if (val) {
          this.maxSalaryShow = true;
          this.buildMaxSalarys(val);
        }
      },
      getJobInfo(jobId) {
        var params = {
          job_id: jobId
        };
        getJobInfo(params).then(m => {
          if (m.errcode === 0) {
            var info = m.data;
            if(info){
              this.form.jobName = info.job_name;
              this.form.jobNature = info.job_nature;
              this.form.positionName = info.position_name;
              this.form.salary = info.salary;
              this.form.city = info.live_city;
              this.form.workAddress = info.address;
              this.form.degree = info.degree;
              this.form.workExp = info.work_exp;
              this.form.jobAdvantage = info.post_advantage;
              this.form.jobDescription = info.description;
            }
          } else {
            this.$message.error('获取职位信息出错，原因：' + m.errmsg);
          }
        });
      }
    }
  };
</script>

<style>

</style>